import React from "react";

import { Navigate, useLocation, useParams } from "react-router-dom";

/**
 * Org admins have no My Accounts: their Account Plans list is Exec Ops → Account
 * Plans (NAV-08). A My Accounts link (a bookmark, a notification, a shared URL)
 * used to land them on "Page not found" (UI tour, 2026-11-03); it now goes to
 * their list, or to Exec Ops → Accounts for any other My Accounts tab.
 */
export const adminTargetFor = (search: string): string =>
  new URLSearchParams(search).get("tab") === "account-plans"
    ? "/ops?tab=account-plans"
    : "/ops?tab=accounts";

const AdminPlansRedirect: React.FC = () => {
  const { orgSlug } = useParams<{ orgSlug?: string }>();
  const { search } = useLocation();
  const target = adminTargetFor(search);
  return <Navigate replace to={orgSlug ? `/${orgSlug}${target}` : target} />;
};

export default AdminPlansRedirect;
